import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LwShell } from '../../components/lw/LwShell';
import { Logo } from '../../components/lw/Logo';
import '../../styles/leasewise/welcome_screen.css';

// Faithful port of templates/welcome_screen.html.
export function Welcome() {
  const navigate = useNavigate();

  return (
    <LwShell>
      <main className="welcome-screen" role="main">
        <div className="welcome-container">
          <section className="branding-section" aria-label="LeaseCheck branding">
            <h1 className="logo-text">LeaseCheck</h1>

            <div className="logo-wrapper">
              <Logo className="logo-image" width={350} height={350} loading="eager" decoding="async" />
            </div>
          </section>

          <section className="value-prop-section" aria-label="Value proposition">
            <h2 className="verify-text">Verify legal compliance easily</h2>
          </section>

          <section className="cta-section" aria-label="Get started">
            <button
              type="button"
              className="start-review-btn"
              role="button"
              aria-label="Start your lease review process"
              onClick={() => navigate('/onboarding')}
            >
              Start Your Review
            </button>
          </section>
        </div>
      </main>
    </LwShell>
  );
}

export default Welcome;
